import { render } from "./AnnouncementAreaComponent.vue?vue&type=template&id=4051f85f&ts=true"
import script from "./AnnouncementAreaComponent.vue?vue&type=script&lang=ts"
export * from "./AnnouncementAreaComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__